import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  }
});

// Helper to get current user's profile
export const getCurrentProfile = async () => {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) return null;
  
  const { data: profile } = await supabase
    .from('profiles')
    .select('*')
    .eq('id', user.id)
    .single();
  
  return profile;
};

// Helper to check if user is participant in transaction
export const isTransactionParticipant = async (transactionId, userId) => {
  const { data } = await supabase
    .from('transaction_participants')
    .select('id')
    .eq('transaction_id', transactionId)
    .eq('user_id', userId)
    .single();
  
  return !!data;
};

// Timeline event creator
export const createTimelineEvent = async (transactionId, eventType, eventText, metadata = {}, actorId = null) => {
  try {
    let userId = actorId;
    if (!userId) {
      const { data: { user } } = await supabase.auth.getUser();
      userId = user?.id;
    }

    const { error } = await supabase
      .from('timeline_events')
      .insert({
        transaction_id: transactionId,
        actor_id: userId,
        event_type: eventType,
        event_text: eventText,
        metadata
      });

    if (error) console.error('Failed to create timeline event:', error);
  } catch (err) {
    console.error('Timeline event error:', err);
  }
};
